var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconHouse = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon--home",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 7.093v-5.093h-3v2.093l3 3zm4 5.907l-12-12-12 12h3v10h18v-10h3zm-5 8h-14v-10.26l7-6.912 7 6.99v10.182zm-5-1h-4v-6h4v6z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHouse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconHouse.fa443cc6.svg";
export { ForwardRef as ReactComponent };